import React, {useEffect, useState} from 'react';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles.js'
import {Link, Redirect, matchPath} from 'react-router-dom';
import Logo from '../../assets/imgs/prospect_brasil.png'
import { useLocation } from 'react-router-dom';
import ExitToAppIcon    from '@material-ui/icons/ExitToApp';
import api from "../../services/api";
import { aplicarValidacao, pode, sair } from "../../services/acesso";
import BuscaGlobal from "../../components/BuscaGlobal";
import AjudaCRM from "../../components/AjudaCRM";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';

const ehPaginaPublica = (caminho) => {
  return caminho === "/"
    || caminho === "/login"
    || caminho === "/politica"
    || caminho.startsWith("/cadastro/")
    || caminho.startsWith("/redefinir-senha/");
};

const usePathname = () => {
  const location = useLocation();
  return location.pathname;
}

// Primeiro trecho da URL ("/leads/10/edit" -> "leads").
const secao = (caminho) => (caminho.split("/")[1] || "");

// Item do menu fica ativo na própria rota e nas rotas filhas
// ("/user/1/edit" ativa "Usuários", "/mailing/3/lead/new" ativa "Mailing").
const itemAtivo = (caminho, destino) => {
  const atual = secao(caminho);
  const alvo = secao(destino);
  return atual === alvo || atual + "s" === alvo;
};

// Título exibido na barra superior: rota exata ou, na falta, a seção do menu.
const tituloDaPagina = (caminho, paths) => {
  const exata = paths.find((p) => p.text && matchPath(caminho, { path: p.to, exact: true }));
  if (exata) return exata.text;
  const menu = paths.find((p) => p.viewMenu && itemAtivo(caminho, p.to));
  return menu ? menu.text : "";
};

function SiderBar(props) {
  const { window } = props;
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [ajudaAberta, setAjudaAberta] = React.useState(false);
  const caminho = usePathname();
  const paginaPublica = ehPaginaPublica(caminho);
  const nomeUsuario = localStorage.getItem("name") || "";
  const titulo = tituloDaPagina(caminho, props.paths);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Fecha o menu do celular ao navegar.
  useEffect(() => {
    setMobileOpen(false);
  }, [caminho]);

  useEffect(() => {
    document.title = titulo ? `${titulo} · CRM Prospect Brasil` : "CRM Prospect Brasil";
  }, [titulo]);

  const drawer = (
    <>
      <div className={classes.drawerConteudo}>
        <div className={`${classes.toolbar} ${classes.logo}`}>
          <Link to="/home" aria-label="Ir para o início">
            <img src={Logo} width={180} alt="Prospect Brasil" />
          </Link>
        </div>
        <Divider />
        <List key={props.acessoVersao || 0} component="nav" aria-label="Menu principal">
          {props.paths.map((path) => {
            if (path.viewMenu === true && (!path.acao || pode(path.acao))) {
              const ativo = itemAtivo(caminho, path.to);
              return (
                <ListItem
                  key={path.to}
                  button
                  component={Link}
                  to={path.to}
                  selected={ativo}
                  aria-current={ativo ? "page" : undefined}
                  className={`${classes.itemMenu} ${ativo ? classes.itemMenuAtivo : ""}`}
                >
                  <ListItemIcon className={classes.iconeMenu}>
                    {path.icon}
                  </ListItemIcon>
                  <ListItemText primary={path.text} primaryTypographyProps={{ style: { fontWeight: "inherit", fontSize: 14 } }} />
                </ListItem>
              )
            }
            return null;
          })}
        </List>
      </div>
      <div className={classes.rodapeMenu}>
        <span className={classes.nomeUsuario} title={nomeUsuario}>{nomeUsuario}</span>
        <span style={{ display: "flex", gap: 4 }}>
          <Button
            onClick={() => setAjudaAberta(true)}
            size="small"
            startIcon={<HelpOutlineIcon />}
          >
            Ajuda
          </Button>
          <Button
            component={Link}
            to="/"
            onClick={sair}
            size="small"
            startIcon={<ExitToAppIcon />}
          >
            Sair
          </Button>
        </span>
      </div>
    </>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const [redirect,setRedirect] = useState(false)

  useEffect(() => {
    if (paginaPublica) return undefined;
    let ativo = true;
    api.get("validar-login")
      .then((resposta) => {
        if (!ativo) return;
        aplicarValidacao(resposta.data);
      })
      .catch(function () {
        if (!ativo) return;
        sair();
        setRedirect(true);
      });
    return () => {
      ativo = false;
    };
  }, [caminho, paginaPublica]);

  if(!paginaPublica && redirect) {
    return <Redirect
      to={{
          pathname: "/login",
      }}
    />
  }

  return (
     <>
      {!paginaPublica ?
        <div className={classes.root} style={{ display: "block", width: "100%" }}>
        <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Abrir menu"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" noWrap className={classes.tituloPagina}>
            {titulo}
          </Typography>
          <BuscaGlobal />
          <Tooltip title="Ajuda do CRM">
            <IconButton color="inherit" aria-label="Ajuda do CRM" onClick={() => setAjudaAberta(true)} style={{ marginLeft: 8 }}>
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
          <span className={classes.usuarioTopo} style={{ marginLeft: 8 }}>{nomeUsuario}</span>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Navegação">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content} id="container-principal" style={{ boxSizing: "border-box", minWidth: 0 }}>
        <div className={classes.toolbar}  />
            {props.children}
      </main>
      <AjudaCRM aberto={ajudaAberta} onFechar={() => setAjudaAberta(false)} />
      </div>
        : props.children
      }
    </>
  );
}



export default SiderBar;
